import { v4 as uuid } from 'uuid'

class User {
  constructor(
    authId,
    name,
    email,
    photoURL = '',
    activityField = '',
    userType = 'client',
    location = '',
  ) {
    this.id = uuid()
    this.authId = authId
    this.name = name
    this.email = email
    this.photoURL = photoURL
    this.activityField = activityField
    this.userType = userType
    this.location = location
  }

  toString() {
    return `${this.name}\n${this.activityField}\n${this.userType}\n${this.location}`
  }
}

// Firestore data converter
export const userConverter = {
  toFirestore(user) {
    return {
      id: user.id,
      authId: user.authId,
      name: user.name,
      email: user.email,
      photoURL: user.photoURL,
      activityField: user.activityField,
      userType: user.userType,
      location: user.location,
    }
  },
  fromFirestore(snapshot, options) {
    const data = snapshot.data(options)
    return new User(
      data.id,
      data.authId,
      data.name,
      data.email,
      data.photoURL,
      data.activityField,
      data.userType,
      data.location,
    )
  },
}

export default User
